<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">
      <h2>Partners </h2>
      <hr class="h2" />
      <div class="container">
        <PartnerTable />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from './SideBar.vue'
import PartnerTable from '../vuetify/PartnerTable.vue'
export default {
  name: 'ManagePartners',
  components: {
    SideBar,
    PartnerTable
  },
  created() {
    // Reset partner, customer and bot details
    localStorage.removeItem('PartnerGUID');
    localStorage.removeItem('customerGUID');
    localStorage.removeItem('customerName');
    localStorage.removeItem('botName');
    localStorage.removeItem('botID');
    localStorage.removeItem('botType');
    localStorage.removeItem('botDID');
    localStorage.removeItem('campaignName');
  }
}
</script>